import React, { forwardRef } from 'react'
import { TextField } from '@mui/material'
import { TextFieldProps } from '@mui/material/TextField/TextField'

import { Field } from '../../types'
import CircularProgressAdornment, {
  CircularProgressAdornmentProps,
} from '../CircularProgressAdornment'
import { ErrorTooltipProps } from '../ErrorTooltip'
import PuiInput from './PuiInput'

export type PuiTextFieldProps = TextFieldProps & {
  readonly ProgressAdornmentProps?: Partial<CircularProgressAdornmentProps>
  readonly TooltipProps?: Partial<ErrorTooltipProps>
  readonly field?: Field
  readonly isLoading?: boolean
  readonly shrink?: boolean
}

const PuiTextField = forwardRef<HTMLDivElement, PuiTextFieldProps>(
  function PuiTextField(
    {
      fullWidth = true,
      margin = 'normal',
      isLoading,
      InputProps = {},
      type = 'text',
      field,
      InputLabelProps,
      ProgressAdornmentProps = {},
      value,
      shrink,
      minRows,
      TooltipProps,
      ...rest
    },
    ref,
  ) {
    const fieldValue = value ?? field?.value

    return (
      <PuiInput TooltipProps={TooltipProps} field={field}>
        <TextField
          InputLabelProps={{
            ...InputLabelProps,
            shrink: fieldValue || shrink ? true : undefined,
          }}
          InputProps={{
            ...InputProps,
            minRows,
            endAdornment: (
              <>
                {InputProps.endAdornment}
                {isLoading && (
                  <CircularProgressAdornment
                    {...ProgressAdornmentProps}
                    circularProgressSize={
                      ProgressAdornmentProps.circularProgressSize || 16
                    }
                    position={ProgressAdornmentProps.position || 'end'}
                  />
                )}
              </>
            ),
          }}
          fullWidth={fullWidth}
          margin={margin}
          ref={ref}
          type={type}
          value={fieldValue}
          variant="standard"
          {...rest}
        />
      </PuiInput>
    )
  },
)

export default PuiTextField
